import { apiRequest } from '@/services/api';
import { SetupBookingData, SetupBookingResponse, OrderStatus, SolutionPurchaseData, SolutionPurchaseResponse } from '@/interfaces';

/**
 * Create a setup booking and get Revolut order token
 */
export async function createSetupBooking(
  bookingData: SetupBookingData
): Promise<SetupBookingResponse> {
  return apiRequest<SetupBookingResponse>(
    true,
    '/revolut/setup-booking',
    'POST',
    undefined,
    bookingData
  );
}

/**
 * Create a solution purchase and get Revolut order token
 * Fixed pricing: €299 implementation + €149/month
 */
export async function createSolutionPurchase(
  purchaseData: SolutionPurchaseData
): Promise<SolutionPurchaseResponse> {
  return apiRequest<SolutionPurchaseResponse>(
    true,
    '/revolut/solution-purchase',
    'POST',
    undefined,
    purchaseData
  );
}

/**
 * Get the status of a Revolut order
 */
export async function getOrderStatus(orderId: string): Promise<OrderStatus> {
  return apiRequest<OrderStatus>(
    true,
    `/revolut/order/${orderId}`,
    'GET'
  );
}

